<div class="modal-container">
    <section class="modal-header">
        <h2>Nuevas condiciones</h2>
        <button mat-icon-button (click)="clickCloseDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </section>
    <section>
        <form [formGroup]="newConditionsForm" (ngSubmit)="submit()">
            <ng-container formArrayName="conditions">    
                <div class="form-body">
                    <mat-card class="cardWithShadow" *ngFor="let condition of conditions.controls; let i = index">
                        <div class="form-condition-header">
                            <button *ngIf="conditions.length > 1" mat-icon-button color="warn" (click)="removeCondition(i)">
                                <mat-icon>remove</mat-icon>
                            </button>
                        </div>
                        <mat-card-content [formGroupName]="i">
                            <app-minute-approval-condition-form-group
                            [parameters]="parameters"
                            [group]="getConditionGroup(i)">
                            </app-minute-approval-condition-form-group>
                        </mat-card-content>
                    </mat-card>
                </div>            
            </ng-container>
            <div class="new-conditions">
                <button type="button" mat-raised-button (click)="addConditions()">
                    Nueva condición
                </button>
            </div>
            <div class="form-bottom">
                <button type="submit" [disabled]="!newConditionsForm.valid" mat-raised-button color="primary">
                    Registrar
                </button>
            </div>
        </form>
    </section>
</div>